<template>
  <div class="detail">
    
    <myHead
      :title="title"
      :subtitle="subtitle"
      v-on:goBack="handleBack"
      @getFooter="getFooter"
      :getMatchHeaderId="this.$route.params.id"
      :back="true"
    />
    <van-notice-bar
      v-for="(item,index) in notices"
      :key="index"
      mode="link"
      scrollable
      left-icon="volume-o"
      @click="handleNotice(item.id)"
    >{{item.name}}</van-notice-bar>
    <div class="listBox">
      <div class="selectBox">
        <van-dropdown-menu id="mydropdown" active-color="#008d44">
          <van-dropdown-item v-model="value" :options="matchDays" @change="handleChange" />
        </van-dropdown-menu>
      </div>
       <div class="recordCheckedBox">只顯示檢錄中
        <van-checkbox  class="isrecordChecked"  
        v-model="recordChecked"
          shape="square" 
          checked-color="#008d44"
           @change="recordCheckedChange"></van-checkbox>
        </div>   
      <van-collapse v-model="activeName" class="mycollapse" @change="handleActiveChange">
        <van-collapse-item
          v-for="(item) in noons"
          :key="item.id"
          :title="item.name"
          :name="item.id"
        >
          <div v-if="noonMatchItemMap[item.id]" class="tableWrap">
            <div class="fixed-arrow">
              <div class="arrow-left"><span></span></div>
              <div class="arrow-right"><span></span></div>
            </div>
          <el-table :data="noonMatchItemMap[item.id]" stripe :style="{'width':tableWidth}" empty-text="暫無數據">
            <el-table-column fixed prop="name" label="項目名稱" v-if="width>765"></el-table-column>
            <el-table-column
              >
                <template slot="header">
                    <div>
                      編號
                    </div>
                </template>
                <template slot-scope="scope" >
                    <div>
                      {{scope.row.number }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="category" label="類別 " v-if="width>765"></el-table-column>
            
            <el-table-column
                 v-if="width<=765" 
                 fixed
              >
                <template slot="header">
                    <div>
                      項目名稱<br>
                      類別
                    </div>
                </template>
                <template slot-scope="scope" >
                    <div>
                      {{scope.row.name }}<br> 
                      {{scope.row.category}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="組別">
              <template slot-scope="scope">
                <div>{{scope.row.team}}</div>
              </template>
            </el-table-column>  
            <!-- <el-table-column label="原定時間">
              <template slot-scope="scope">
                <div>{{getTime(scope.row.originalTime)}}</div>
              </template>
            </el-table-column> -->
             <el-table-column label="比賽時間"  align="center">
              <template slot-scope="scope">
                <van-icon
                  v-if="scope.row.realTimeStar"
                  name="star"
                  class="star"
                  size="12px"
                  color="#008d44"
                />
                <div>{{getTime(scope.row.realTime)}}</div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="實際時間">
              <template slot-scope="scope">
                <div>{{getTime(scope.row.realTime)}}</div>
              </template>
            </el-table-column> -->
            <el-table-column label="檢錄時間"  align="center">
              <template slot-scope="scope">
                <van-icon
                  v-if="scope.row.checkTimeStar"
                  name="star"
                  class="star"
                  size="12px"
                  color="#008d44"
                />
                <div>{{getTime(scope.row.checkTime)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="檢錄剩時">
              <template slot-scope="scope">
                <div v-html="scope.row.countDownTime"></div>
              </template>
            </el-table-column>
            
            <el-table-column label="參賽名單" align="center">
              <template slot-scope="scope">
                <div>
                  <van-icon
                  v-if="scope.row.rosterStar"
                  name="star"
                  class="star"
                  size="12px"
                  color="#008d44"
                />
                </div>
                <van-icon
                  class="iconBox"
                  v-if="(scope.row.rosterExcel&&scope.row.rosterExcel!=null&&scope.row.rosterExcel!=' ')||(scope.row.rosterPdf&&scope.row.rosterPdf!=null&&scope.row.rosterPdf!=' ')"
                  @click="handleClick(scope.row,0)"
                  name="orders-o"
                  size="22px"
                  color="#008d44"
                />
                <van-icon v-else name="orders-o" size="22px" color="#403f414d" />
               
              </template>
            </el-table-column>
            <div v-if="(noonMatchItemMap[item.id].length ? noonMatchItemMap[item.id][0].extFields[0] : false)">
              <el-table-column
                v-for="(ztem,zndex) in noonMatchItemMap[item.id][0].extFields"
                :key="zndex"
               
               
              >
                <template slot="header" >
                    <div>{{ztem}}</div>
                </template>
                <template slot-scope="scope">
                    <div>
                      {{scope.row.extValues[zndex]}}
                    </div>
                    <!-- <div
                      class="tableData"
                      v-for="(jtem,jndex) in noonMatchItemMap[item.id]"
                      :key="jndex"
                    >
                      <div v-for="(ytem,yndex) in jtem.extValues" :key="yndex">
                        <div v-if="zndex==yndex">{{ zndex==yndex}} || {{ytem}}</div>
                      </div>
                    </div> -->
                </template>
              </el-table-column>
            </div>
            <el-table-column label="成績結果" align="center" >
              <template slot-scope="scope">
                <div>
                  <van-icon
                  v-if="scope.row.resultStar"
                  name="star"
                  class="star"
                  size="12px"
                  color="#008d44"
                />
                </div>
                <van-icon
                  class="iconBox"
                  v-if="(scope.row.resultExcel&&scope.row.resultExcel!=null&&scope.row.resultExcel!=' ')||(scope.row.resultPdf&&scope.row.resultPdf!=null&&scope.row.resultPdf!=' ')"
                  @click="handleClick(scope.row,1)"
                  name="orders-o"
                  size="22px"
                  color="#008d44"
                />
                <van-icon v-else name="orders-o" size="22px" color="#403f414d" />
                 <van-icon
                  class="iconBox captureUrl"
                  :style="captureUrlStyle"
                  v-if="scope.row.captureUrl&&scope.row.captureUrl!=null&&scope.row.captureUrl!=' '"
                  @click="handleClick(scope.row,3)"
                  size="22px"
                  color="#008d44"
                />
                <van-icon class="iconBox captureUrlNo" v-else  size="22px" color="#403f414d" :style="captureUrlNoStyle"  />
              </template>
            </el-table-column>
          </el-table>
          </div>
          <!-- <div class="table" v-if="noonMatchItemMap[item.id].length>0">
            <div class="tableLabel" v-if="width>767">
              <div class="tableHead">
                <div>{{tableHead[0]}}</div>
              </div>
              <div v-for="(jtem,jndex) in noonMatchItemMap[item.id]" :key="jndex" class="tableData">
                <div>{{jtem.name}}</div>
              </div>
            </div>
            <div class="tableLabel" v-else>
              <div class="tableHead">
                <div>{{tableHead[0]}}</div>
                <div>{{tableHead[1]}}</div>
              </div>
              <div v-for="(jtem,jndex) in noonMatchItemMap[item.id]" :key="jndex" class="tableData">
                <div>{{jtem.name}}</div>
                <div>{{jtem.category}}</div>
              </div>
            </div>
            <div class="scrollView">
              <div class="scrollBox flexBox" :style="{'width':tableWidth}">
                <div class="tableCol" v-if="width>767">
                  <div class="tableHead">
                    <div>{{tableHead[1]}}</div>
                  </div>
                  <div
                    class="tableData"
                    v-for="(jtem,jndex) in noonMatchItemMap[item.id]"
                    :key="jndex"
                  >
                    <div>{{jtem.category}}</div>
                  </div>
                </div>
                <div class="tableCol">
                  <div class="tableHead">
                    <div>{{tableHead[2]}}</div>
                  </div>
                  <div
                    class="tableData"
                    v-for="(jtem,jndex) in noonMatchItemMap[item.id]"
                    :key="jndex"
                  >
                    <div>{{getTime(jtem.originalTime)}}</div>
                  </div>
                </div>
                <div class="tableCol">
                  <div class="tableHead">
                    <div>{{tableHead[3]}}</div>
                  </div>
                  <div
                    class="tableData"
                    v-for="(jtem,jndex) in noonMatchItemMap[item.id]"
                    :key="jndex"
                  >
                    <van-icon
                      v-if="jtem.markStar"
                      name="star"
                      class="star"
                      size="12px"
                      color="#008d44"
                    />
                    <div>{{getTime(jtem.realTime)}}</div>
                  </div>
                </div>
                <div class="tableCol">
                  <div class="tableHead">
                    <div>{{tableHead[4]}}</div>
                  </div>
                  <div
                    class="tableData"
                    v-for="(jtem,jndex) in noonMatchItemMap[item.id]"
                    :key="jndex"
                  >
                    <van-icon
                      v-if="jtem.markStar"
                      name="star"
                      class="star"
                      size="12px"
                      color="#008d44"
                    />
                    <div>{{getTime(jtem.checkTime)}}</div>
                  </div>
                </div>
                <div class="tableCol">
                  <div class="tableHead">
                    <div>{{tableHead[5]}}</div>
                  </div>
                  <div
                    class="tableData"
                    v-for="(jtem,jndex) in noonMatchItemMap[item.id]"
                    :key="jndex"
                  >
                    <div v-html="jtem.countDownTime"></div>
                  </div>
                </div>
                <div v-if="noonMatchItemMap[item.id][0].extFields">
                  <div
                    class="tableCol"
                    v-for="(ztem,zndex) in noonMatchItemMap[item.id][0].extFields.split(',')"
                    :key="zndex"
                  >
                    <div class="tableHead">
                      <div>{{ztem}}</div>
                    </div>
                    <div
                      class="tableData"
                      v-for="(jtem,jndex) in noonMatchItemMap[item.id]"
                      :key="jndex"
                    >
                      <div v-for="(ytem,yndex) in jtem.extValues.split(',')" :key="yndex">
                        <div v-if="zndex==yndex">{{ytem}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tableCol">
                  <div class="tableHead">
                    <div>{{tableHead[6]}}</div>
                  </div>
                  <div
                    class="tableData"
                    v-for="(jtem,jndex) in noonMatchItemMap[item.id]"
                    :key="jndex"
                    style="height:42px;display:flex;align-items: center"
                  >
                    <van-icon 
                      class="iconBox"
                      v-if="(jtem.rosterExcel&&jtem.rosterExcel!=null&&jtem.rosterExcel!=' ')||(jtem.rosterPdf&&jtem.rosterPdf!=null&&jtem.rosterPdf!=' ')"
                      @click="handleClick(jtem,0)"
                      name="orders-o"
                      size="24px"
                      color="#008d44"
                    />
                    <van-icon v-else name="orders-o" size="24px" color="#403f41" />
                  </div>
                </div>
                <div class="tableCol">
                  <div class="tableHead">
                    <div>{{tableHead[7]}}</div>
                  </div>
                  <div
                    class="tableData"
                    v-for="(jtem,jndex) in noonMatchItemMap[item.id]"
                    :key="jndex"
                    style="height:42px;display:flex;align-items: center"
                  >
                    <van-icon
                    class="iconBox"
                      v-if="(jtem.resultExcel&&jtem.resultExcel!=null&&jtem.resultExcel!=' ')||(jtem.resultPdf&&jtem.resultPdf!=null&&jtem.resultPdf!=' ')"
                      @click="handleClick(jtem,1)"
                      name="orders-o"
                      size="24px"
                      color="#008d44"
                    />
                    <van-icon v-else name="orders-o" size="24px" color="#403f41" />
                  </div>
                </div>
              </div>
            </div>
          </div>-->
        </van-collapse-item>
      </van-collapse>
       <van-cell
        v-for="(item,index) in matchTables"
        :key="index"
        class="mycell mycell-color"
        :title="item.title"
        :excelUrl="item.excelUrl"
        :pdfUrl="item.pdfUrl"
        :id="item.id"
        is-link
        @click="handleClick(item,4)"
      />
      <van-cell
        v-for="(item,index) in matchDescs"
        :key="index"
        class="mycell"
        :title="item.name"
        is-link
        :to="'/tips/'+item.id"
      />
    </div>
    <div class="bottomlogo-box">
      <a class="logoBox" :href="item.address" v-for="item in advBottomLogoList" :key="item.id" @click="bottomLogohandleClick" >
        <img :src="item.image" alt="">
        <p>{{item.name}}</p>
      </a>
    </div>
    <div id="footer" v-if="footer">
      <span>{{footer}}</span>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//导入接口
import { GetMatchDetail, GetMatchDay, GetmatchTables,GetDefaultDate } from "@/request/api";
import myHead from "@/components/myHead.vue";
import  captureUrlImg  from '@/assets/images/captureUrl.png';
import  captureUrlNoImg  from '@/assets/images/captureUrlNo.png';
// import { default_date } from "@/assets/js/default_date.js";

import {
  Icon,
  DropdownMenu,
  DropdownItem,
  NoticeBar,
  Collapse,
  CollapseItem,
  Cell,
  Dialog,
  Toast,
  Checkbox
} from "vant";

function countDownFun(item) {
  let tmp =
    item.checkTime + item.countdownLen * 60 * 1000 - new Date().getTime();
  if (item.countdownStart > 0) {
    if (0 < tmp && tmp <= item.countdownLen * 60 * 1000) {
      let returnTime = getTime(tmp);
      return `<span style="color:#e50085">${returnTime}</span>`;
    } else if (tmp > item.countdownLen * 60 * 1000) {
      return `<span style="color:#8c8e90">未開始</span>`;
    } else {
      return `<span style="color:#008d44">已結束</span>`;
    }
  } else {
    return `<span style="color:#8c8e90">未開始</span>`;
  }
}



function getTime(timestamp) {
  let countDownTime = "";
  if (timestamp) {
    var min = Math.floor((timestamp / 1000 / 60) % 60);
    var sec = Math.floor((timestamp / 1000) % 60);
    if (min < 10) {
      min = "0" + min;
    }
    if (sec < 10) {
      sec = "0" + sec;
    }
    countDownTime = min + ":" + sec;
  } else {
    countDownTime = "-";
  }

  return countDownTime;
}

function isItemChecking(item){
  if(!item.checkTime||!item.countdownLen){
  return false;
  }
  var now = new Date().getTime();
  if(now >= item.checkTime && item.checkTime + item.countdownLen * 60 *1000 >= now ){
  return true;
  }
  return false;
}
export default {
  name: "Detail",
  data() {
    return {
      captureUrlStyle: {
        background: "url("+(captureUrlImg+")"),
        backgroundSize: "cover",
      },
      captureUrlNoStyle: {
        background: "url("+(captureUrlNoImg+")"),
        backgroundSize: "cover",
      },
      title: "",
      subtitle: "",
      notices: [],
      noticesText: "",
      matchDescs: [],
      matchTables: [],
      value: 0,
      matchDays: [],
      noons: [],
      noonMatchItemMap: {},
      extFields: [],

      activeName: [],
      tableHead: [
        "項目名稱",
        "類別",
        "組別",
        "原定時間",
        "開始時間",
        "實際時間",
        "檢錄時間",
        "倒計時",
        "參賽名單",
        "成績結果"
      ],
      footer: "",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        }
      ],
      advBottomLogoList:[],
      recordChecked: false
    };
  },
  components: {
    [Icon.name]: Icon,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [NoticeBar.name]: NoticeBar,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Cell.name]: Cell,
    [Dialog.name]: Dialog,
    [Checkbox.name]: Checkbox,
    myHead
  },
  computed: {
    width: function() {
      return document.body.clientWidth;
    },
    tableWidth: function() {
      return document.body.clientWidth > 767
        ? "100%"
        : (this.tableHead.length - 2) * 120 + "px";
    }
  },
  mounted() {
    console.log(this.$route.params.id);
    let _this = this;
    this.GetMatchDetail(this.$route.params.id);
    GetmatchTables(this.$route.params.id).then(res => {
        if (res.success && res.data.bottomLogos.length) {
         for (let i=0; i < res.data.bottomLogos.length; i++){
            this.advBottomLogoList.push(res.data.bottomLogos[i])
          }
        }
        if (res.success && res.data.matchTables.length) {
          for (let i=0; i < res.data.matchTables.length; i++){
            this.matchTables.push(res.data.matchTables[i])
          }
        }
      })
  },
  methods: {
    recordCheckedChange (){
            this.GetMatchDay();
    },
     bottomLogohandleClick(){
      console.log(this.$route)
      if(this.$route.path!="/"){
      this.$router.push({
        name: 'Home'
      })
      }

    },
    handleNotice: function(id) {
      this.$router.push({
        path: `/tips/${id}`
      });
    },
    getFooter: function(val) {
      this.footer = val;
    },
    handleBack: function() {
      this.$router.go(-1);
    },
    handleChange: function(value) {
      this.GetMatchDay();
    },
    handleClick: function(item, type) {
      console.log(item.rosterExcel, item.resultExcel);
      localStorage.setItem("getMatchHeaderId", this.$route.params.id);
      if (type == 0) {
        // 參賽名單
        if (item.rosterExcel && item.rosterExcel != " ") {
          this.$router.push({
            path: "/about",
            query: {
              title: item.name,
              subtitle: item.category,
              id: item.id,
              type: type
            }
          });
        } else {
          if (item.rosterPdf && item.rosterPdf != " ") {
            // window.open(item.rosterPdf, "_blank");
            window.open('http://202.175.22.168/manager/preview.html?file=' + item.rosterPdf, "_blank");
          }
        }
      } else if (type == 1){
        // 成績結果:excel就打开，pdf就下载
        if (item.resultExcel && item.resultExcel != " ") {
          this.$router.push({
            path: "/about",
            query: {
              title: item.name,
              subtitle: item.category,
              id: item.id,
              type: type
            }
          });
        } else {
          if (item.resultPdf && item.resultPdf != " ") {
            // window.open( item.resultPdf, "_blank");
            window.open('http://202.175.22.168/manager/preview.html?file=' + item.resultPdf, "_blank");
          }
        }
      }  else if (type == 3){
        // 成绩结果captureUrl，可能是图片excelpdf等一切都是下载
        if (item.captureUrl !=  " " && item.captureUrl != null){
          // window.open(item.captureUrl, "_blank");
          window.open('http://202.175.22.168/manager/preview.html?file=' + item.captureUrl, "_blank");
        }
      } else if (type == 4){
        // 报名名单
        if (item.excelUrl !=  " " && item.excelUrl != null){
          this.$router.push({
            path: "/about",
            query: {
              title: this.title,
              subtitle: this.subtitle,
              id: item.id,
              type: type
            }
          });
        } else if (item.pdfUrl !=  " " && item.pdfUrl != null){
          // window.open(item.pdfUrl, "_blank");
          window.open('http://202.175.22.168/manager/preview.html?file=' + item.pdfUrl, "_blank");
        } else {
          return false
        }
      }
    },
    GetMatchDetail:  function(id) {
      GetMatchDetail(id).then( async res => {
        console.log(res.data.match.name);
        const { notices, matchDescs, match, matchDays } = res.data;
        if (res.success) {
          debugger
         let defaultDateRes = await GetDefaultDate();
         let default_date = defaultDateRes || '';
         console.info('defaultDateRes==========', defaultDateRes)
         
          let dateFlag = 0;
          matchDays.forEach((element, index) => {
            if( new Date(default_date).getTime() == element.startDate){
              dateFlag = index;
            } 
            this.matchDays.push({
              text:
                `第${index + 1}天 - ` + this.getFormatDate(element.startDate),
              value: element.id
            });
          });
          debugger
          this.value =  matchDays[dateFlag].id;
          this.matchDescs = matchDescs;
          this.title = match.name;
          this.subtitle = this.getFormatDate(match.startDate);
          // this.detailBgImage = match.bgImage;
          // localStorage.setItem("detailBgImage", match.bgImage);
          notices.forEach(element => {
            this.noticesText = element.name;
          });
          this.notices = notices;

          this.GetMatchDay();
        }
      });
    },
    GetMatchDay: function() {
      let _this = this;
      const { value } = this;
      this.noons = [];
      this.noonMatchItemMap = [];
      var activeName = [];
      clearInterval(this.temp);
      GetMatchDay(value).then(res => {      
        if (res.success) {
          let getNoonMatchItemMap = {};
          let { noonMatchItemMap, noons } = res.data;
          activeName = Object.keys(noonMatchItemMap);
         activeName.forEach(function (key) {
          getNoonMatchItemMap[key] = []
            if (_this.recordChecked ){
                noonMatchItemMap[key].forEach((item, index, array) => {
                console.log(key,index, item, isItemChecking(item))
                      if(isItemChecking(item)){
                           item.countDownTime = countDownFun(item);
                          item.extFields = item.extFields.split(",");
                             item.extValues = item.extValues.split(",");
                            getNoonMatchItemMap[key].push(item);
                              } 
                })
            } else {
               noonMatchItemMap[key].forEach((item, index, array) => {
                  item.countDownTime = countDownFun(item);
                  item.extFields = item.extFields.split(",");
                  item.extValues = item.extValues.split(",");
                  getNoonMatchItemMap[key].push(item);

                })
            }
          });

          this.noonMatchItemMap = getNoonMatchItemMap;
          this.noons = noons;
          this.activeName = activeName.map(Number);
          this.timer();
        }
      });
    },
    timer() {
      //页面多个定时器 //主要逻辑都在这页面更新
      let _that = this;
      this.temp = setInterval(() => {
        let { noonMatchItemMap, noons } = _that;
        Object.keys(noonMatchItemMap).forEach(function(key) {
          noonMatchItemMap[key].forEach(item => {
            item.countDownTime = countDownFun(item);
          });
        });
      }, 1000);
    },
    checkCountDown: function(item) {},
    //时间转换函数
    getTime: function(nS) {
      if (nS > 0) {
        var date = new Date(parseInt(nS));
        var year = date.getFullYear();
        var mon = date.getMonth() + 1;
        var day = date.getDate();
        var hours = date.getHours();
        var minu = date.getMinutes();
        var sec = date.getSeconds();

        if (hours < 10) {
          hours = "0" + hours;
        }
        if (minu < 10) {
          minu = "0" + minu;
        }
        return hours + ":" + minu;
      } else {
        return "-";
      }
    },
    handleActiveChange: function(e) {
      console.log(e);
    },
    getFormatDate: function(date) {
      var enMonth = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC"
      ];
      var date = new Date(date);
      var year = date.getFullYear();
      var month = date.getMonth();
      var nowDate = date.getDate();
      if (nowDate >= 0 && nowDate <= 9) {
        nowDate = "0" + nowDate;
      }
      var newDate = nowDate + " " + enMonth[month] + " " + year;
      return newDate;
    }
  }
};
</script>

<style lang="less">
.tableWrap {
  position: relative;
}
.detail {
   .fixed-arrow {
    width: 30px;
    height: 80px;
    position: absolute;
    z-index: 99;
    top: 0;
    right: 0;

    .arrow-left,
    .arrow-right {
      width: 30px;
      height: 35px;
      background: #000;
      opacity: .8;
      text-indent: 11px;
    }
    .arrow-right {
      opacity: .6;
    }
    .arrow-left span {
      display: inline-block;
      width:0;
      height:0;
      border-top:7px solid transparent;
      border-bottom:7px solid transparent;
      border-left:10px solid #fff;
      margin-top: 10px;
    }
    .arrow-right span {
      display: inline-block;
      width:0;
      height:0;
      border-top:7px solid transparent;
      border-bottom:7px solid transparent;
      border-right:10px solid #fff;
      margin-top: 10px;
    }
  }
  .selectBox {
    padding: 8px 16px;
    background: #bd936b;
    .van-dropdown-menu__bar {
      height: 30px;
    }
    .van-dropdown-menu__title {
      font-size: 14px !important;
    }
    .van-cell__title {
      font-size: 12px !important;
    }
    .van-popup--top {
      left: 20px;
      right: 20px;
      width: auto;
    }
  }
  .mycollapse {
    .van-collapse-item__title {
      background: #008d44;
      color: white;
      font-size: 18px;
      .van-cell__right-icon {
        color: white;
      }
    }
    .van-cell:not(:last-child)::after {
      left: 0px;
    }
    .van-collapse-item__content {
      padding: 0px;
    }
  }
  .mycell {
    background: #403f41;
    color: white;
    .van-icon {
      color: white;
    }
  }
   .mycell.mycell-color {
      background-color: #ed6a0c; 
    }
  .van-notice-bar {
    background: #ea5a28;
    color: white;
    position: relative;
    &::after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 0;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
  }
  .van-notice-bar:last-of-type {
    border: 0;
  }

  .el-table td, .el-table th {
    // padding: 6px 0;
  }
  .el-table__fixed-header-wrapper, .el-table__header-wrapper {   
    background: #403f41 !important;
    color: white !important;
    & th {
      background: #403f41 !important;
      color: white !important;
    }
  }
  .el-table__fixed-body-wrapper, .el-table__body-wrapper{
    .el-table__row:nth-child(even){
      background: #e0e1e1;
    }
     .el-table__row:nth-child(odd){
      background: #ebebec;
    }
  }
}
.recordCheckedBox{
  position: relative;
  padding: 10px 50px;
  background: #bd936b;
  border-top: 1px solid #dec9b5;
  font-size: 16px;
  text-align: right;
  color: #fff!important;
}
.isrecordChecked {
  position: absolute;
  right: 16px;
  top: 12px;
}

.recordCheckedBox .van-checkbox__icon .van-icon {
  background: #fff;
}

</style>
<style scoped lang="less">
.table {
  display: flex;
  font-size: 14px;
  .scrollView {
    width: 100%;
    overflow-x: auto;
  }
  .tableLabel {
    width: 180px;
  }
  .tableLabel,
  .tableCol {
    display: flex;
    flex-direction: column;
    .tableData:nth-child(even) {
      background: #ebebec;
    }
    .tableData:nth-child(odd) {
      background: #e0e1e1;
    }
  }
  .flexBox {
    display: flex;
  }
  .tableHead {
    background: #403f41;
    color: white;
    font-size: 16px;
  }
  .tableHead,
  .tableData {
    padding: 0px 10px;
    box-sizing: border-box;
    position: relative;
  }
  
}
.star.van-icon-star {
    position: absolute;
      top: 2px;
      left: calc(50% - 6px);
  }
.iconBox {
  &:hover {
    cursor: pointer;
  }
}
.bottomlogo-box {
  margin-top: 20px;
  display: flex;
  flex: 1;
  text-align: center;
  justify-content: center;
  .logoBox img {
      display: inline-block;
      width: 80px;
      height: 80px;
      margin: 0 5px;
  }
  p {
    font-size: 14px;
    color: #606266;
    text-align: center;
    margin: 0;
  }
}
.captureUrlNo,
.captureUrl {
  display: inline-block;
  width: 16px;
  height: 21px;
  
}
.van-icon {
  vertical-align: -webkit-baseline-middle;
}



@media screen and (max-width: 767px) {
  .scrollView {
    .tableHead,
    .tableData {
      height: 42px;
      line-height: 42px;
    }
  }
}
@media screen and (min-width: 768px) {
  .tableHead,
  .tableData {
    height: 42px;
    line-height: 42px;
  }
}
@media screen and (min-width: 1024px) {
  .table {
    .tableHead,
    .tableData {
      flex: 1;
    }
    .tableCol {
      flex: 1;
    }
  }
}
@media screen and (max-width: 1023px) {
  .table {
    .tableHead,
    .tableData,
    .tableCol {
      min-width: 100px;
    }
  }
}
@media screen and (min-width: 415px) {
  .fixed-arrow {
    display: none;
  }
}
</style>
